<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
   <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
    <v-card class="box">
      <v-toolbar dense class="toolbar" flat color="white">
        <v-toolbar-title>My Kids</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center">
        <v-col sm="4" md="4" cols="12">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
            item-value="id" label="Select Academic Year" outlined @change="getChildInfo()" />
        </v-col>
      </v-row>
      <br />
    </v-card>
    <v-card class="box" v-if="childinfo.length > 0">
      <div v-for="(child, index) in childinfo" :key="child.learner">
        <v-card style="margin-left: 10px; background-color: #eeeeee" max-width="350">
          <v-col cols="12">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">{{
                  child.name
                  }}</v-list-item-title>
                <v-list-item-subtitle>Standard: <b>{{ child.standard }}</b></v-list-item-subtitle>
                <v-list-item-subtitle>Division: <b>{{ child.division }}</b></v-list-item-subtitle>
                <v-list-item-subtitle>Roll Number: <b>{{ child.rollno }}</b></v-list-item-subtitle>
              </v-list-item-content>
              <template v-if="childinfo.avtarlocation">
                <v-avatar size="80">
                  <v-img :src="awspath + childinfo.avtarlocation" :lazy-src="`${awspath + childinfo.avtarlocation}`" />
                </v-avatar>
                <!-- <v-list-item-avatar
                tile
                size="80"
                color="grey"
                :src="awspath+childinfo.avtarlocation"
              ></v-list-item-avatar> -->
              </template>
              <template v-else>
                <v-avatar :color="index % 2 == 0 ? 'info' : 'teal'" size="48">
                  <span class="white--text headline">{{ child.name[0] }}</span>
                </v-avatar>
              </template>
            </v-list-item>

            <v-card-actions>
              <v-spacer> </v-spacer>
              <v-btn :disabled="!child.division_off" title="View" class="ma-2" tile small outlined color="primary"
                @click="viewattendance(child.learner,child.cay)"><v-icon left>mdi-eye</v-icon> View Attendance</v-btn>
            </v-card-actions>
          </v-col>
        </v-card>
      </div>
    </v-card>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Attendance Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/jp9PLcgFT68?si=DiRpz3oI16h-eNQj"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
  <script>
  import axios from "axios";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
  export default {
    components: {
      Breadcrumbs,
    },
  data: () => ({
    childinfo: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    ay_list: [],
    ay: "",
    videoDialog:false,
    awspath: localStorage.getItem("awspath"),
  }),

  mounted() {
    this.onload();
  },
  methods: {
    onload() {
      axios
        .post("Academics/studentAttendanceHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.ay_list = res.data.ay_list;
            // (this.ay=res.data.cay)
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    getChildInfo() {
      const data = {
        ay: this.ay,
      };
      this.childinfo = [];
      axios
        .post("/Academics/getMyChildInfo", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.childinfo = res.data.childinfo;
            //this.load=true
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    viewattendance(learner, cay) {
    
   
     
      //alert(learner)
      this.$store.commit("setlid", learner);
      this.$store.commit("setcay_id", cay);
      this.$router.push({ name: "view-child-attendance" });
    },
  },
};
</script>